import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type JobOpeningOfferItem = ResultOf<
  typeof workOrderJobOpeningOfferListQuery
>["workOrderJobOpeningOffers"]["data"][number];

export const workOrderJobOpeningOfferListQuery = graphql(`
  query WorkOrderJobOpeningOfferList(
    $job_opening_id: ID
    $status: [WorkOrderJobOpeningOfferStatus!]
    $orderByStatus: SortOrder
    $page: Int
    $first: Int!
  ) {
    workOrderJobOpeningOffers(
      job_opening_id: $job_opening_id
      status: $status
      orderByStatus: $orderByStatus
      first: $first
      page: $page
    ) {
      data {
        id
        status
        jobOpening {
          id
          description
          depart_at
          deliver_at
          workOrder {
            id
          }
        }
        proDriver {
          id
          name
          email
          phone
          rating
          numberOfCompletedAssignments
          license_type
        }
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);
